module.exports = __webpack_public_path__ + "img/loading.666b9bf6.png";